<template>
  <section>
    <h1 class="title">{{ name }}</h1>
    <p>As Fisical Fitness founder I am passionate about health and fitness and I strongly believe in the necessity for an active lifestyle, encompassing a balance of all the compulsory components of fitness. </p>
    <p>
      My interest in fitness started with training towards and earning a black belt in Karate as a symbol of proficiency in martial arts.
    </p>
    <p>
      My philosophy focuses on continual lifelong learning as I work towards enhancing the well-being of my clients by empowering them with the knowledge, skills, support, guidance and resources to assist and inspire them on their journey to a healthier lifestyle.
    </p>    
    <p>
      With an extensive background in coaching, I create a training environment that not only motivates but also empowers individuals to continually challenge themselves in a fun and rewarding way.
    </p>
  </section>
</template>

<script>
export default {
  data() {
    return {
      name: 'Zach Frangou',
    };
  },
};
</script>

<style scoped src="./About.css"></style>
